import React from "react";
import { NavLink, Link } from "react-router-dom";
import Button from "../components/buttons/Button";
import Avatar from "../components/avatar/Avatar";

export default ({ user, logout }) => {
  const currentPath = window.location.pathname;
  return (
    <div className="oMenuMobile">
      <div className="oMenuMobile_links">
        <NavLink to="/jobs" className="oMenuMobile_link">
          Jobs
        </NavLink>
        <NavLink to="/designers" className="oMenuMobile_link">
          Designers
        </NavLink>
        <NavLink to="/showcase" className="oMenuMobile_link">
          Showcase
        </NavLink>
        <NavLink to="/tools" className="oMenuMobile_link">
          Tools
        </NavLink>
        <NavLink to="/about-us" className="oMenuMobile_link">
          About
        </NavLink>
      </div>
      <div className="oMenuMobile_auth">
        {user ? (
          <div className="oMenuMobile_profile">
            <div>
              <div className="oMenuMobile_line">
                <Avatar avatar={user.avatar} small />
                <Link to={`/${user.role}/${user.slug}`}>
                  <h3>Profile</h3>
                </Link>
              </div>
              <Link to="/settings">
                <Button outlined>Edit my profile</Button>
              </Link>
            </div>
            <a onClick={logout} className="oMenuMobile_link -signOut" href="/">
              Sign out
            </a>
          </div>
        ) : (
          <>
            <NavLink
              to={"/login/?redirect_url=" + currentPath}
              className="oMenuMobile_link -signIn"
            >
              Log in
            </NavLink>
            <NavLink to="/signup" className="oMenuMobile_signUp">
              <Button big rounded>
                Sign up
              </Button>
            </NavLink>
          </>
        )}
      </div>
    </div>
  );
};
